import { createNewEntitySlice } from 'containers/App/modules/entities/entities.utils';
import { ENTITY_TYPES } from 'containers/App/modules/entities/entities.constants';

const customerDetailsEntitySlice = createNewEntitySlice({
	name: ENTITY_TYPES.CUSTOMER_DETAILS
});

const { reducer, actions, selectors } = customerDetailsEntitySlice;

export default reducer;